<form
  class="form form-contact"
  [formGroup]="loginForm"
  (ngSubmit)="onLogin()"
  data-response-message-animation="slide-in-up"
>
  <div class="input-wrapper">
    <input
      class="form-input"
      formControlName="nombre"
      type="text"
      placeholder="Nombre"
      id="nombre"
    />
    <label
      for="nombre"
      tabindex="0"
      class="form-label"
      #nameInput
      (click)="focusLabel()"
    >
      Nombre
    </label>
  </div>

  <div class="input-wrapper">
    <input
      class="form-input"
      formControlName="email"
      type="text"
      placeholder="Email válido"
      id="email"
    />
    <label
      for="email"
      tabindex="0"
      class="form-label"
      #nameInput
      (click)="focusLabel()"
    >
      Email válido</label
    >
  </div>

  <div class="input-wrapper">
    <input
      class="form-input"
      formControlName="telefono"
      type="text"
      placeholder="Teléfono"
      id="telefono"
      required
    />
    <label
      for="telefono"
      tabindex="0"
      class="form-label"
      #nameInput
      (click)="focusLabel()"
    >
      Teléfono
    </label>
  </div>

  <div class="input-wrapper">
    <textarea
      formControlName="observaciones"
      id="observaciones"
      class="form-input"
      placeholder="¿En qué podemos ayudarte?"
      rows="4"
      required
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      #inputElement
    ></textarea>
    <label
      for="observaciones"
      tabindex="0"
      class="form-label"
      style="margin-top: -3rem;"
      #labelElement
    >
      ¿En qué podemos ayudarte?
    </label>
  </div>
  <label style="color: white; font-size: 15px;">
    <input type="checkbox" formControlName="acceptTerms" />
    He leído y acepto la Política de Privacidad
  </label>
  <div class="form-group boton-enviar" style="margin-right: 4px;">
    <button
      id="contact-submit"
      name="submit"
      type="submit"
      class="btn btn-primary bold"
      [disabled]="!loginForm.value.acceptTerms"
    >
      Enviar mensaje
    </button>
  </div>
</form>

<div class="response-message">
  <div class="section-heading">
    <i class="fas fa-check font-lg"></i>
    <p class="font-md m-0">¡Gracias!</p>
    <p class="response">
      Su mensaje a sido enviado, contactaremos con usted a la mayor brevedad
      posible.
    </p>
  </div>
</div>
